<template>
  <v-menu offset-y>
    <template v-slot:activator="{ on, attrs }">
      <button
        v-bind="attrs"
        v-on="on"
        class="qr-lang-btn scan-touch-target"
        :aria-label="$t('language')"
      >
        {{ $i18n.locale.toUpperCase() }}
        <svg width="9" height="6" viewBox="0 0 9 6" fill="none">
          <path
            d="M1 1l3.5 4L8 1"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </button>
    </template>

    <v-list>
      <v-list-item
        v-for="(locale, index) in locales"
        :key="index"
        @click="changeLocale(locale.code)"
      >
        <v-list-item-avatar size="25" class="mr-2">
          <v-img :src="locale.flag" />
        </v-list-item-avatar>
        <v-list-item-title
          :class="locale.code === $i18n.locale ? 'primary--text' : ''"
        >
          {{ locale.name }}
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "QrLanguageMenu",
  computed: {
    ...mapGetters({
      locales: "auth/locales",
    }),
  },
  methods: {
    changeLocale(code) {
      localStorage.setItem("locale", code);
      this.$i18n.locale = code;
    },
  },
};
</script>

<style scoped>
.scan-touch-target {
  min-width: 44px !important;
  min-height: 44px !important;
}

.qr-lang-btn {
  display: flex;
  align-items: center;
  gap: 4px;
  height: 32px;
  padding: 0 9px;
  border-radius: 999px;
  border: 0;
  background: transparent;
  color: rgba(31, 24, 18, 0.55);
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.4px;
  cursor: pointer;
  font-family: inherit;
  min-width: 44px;
  min-height: 44px;
}
</style>

